<template>
    <div class="table__filters" ref="filters">
        <div :class="isActive" class="select" @click="toggle">
            <div v-if="show" v-click-outside="hide"></div>
            <div class="select__inner" :class="isActive">
                <div class="select__title" v-if="select">{{ $t(select) }}</div>
                <div class="select__title" v-else>{{ $t('importColumnSelectColumn') }}</div>
                <div class="select__arrow"></div>
            </div>
            <transition name="fade">
                <div v-if="show" :class="`sub Active`">
                    <div class="menu" v-for="(item, index) in list" :key="index" @click="updateFilter(item)">
                        <span class="menu__title">{{ $t(item.title) }}</span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import toggle from '@/mixins/toggle.vue'
    export default {
        mixins: [toggle],
        props: ['options', 'selected', 'field'],
        data() {
          return {
              select: ''
          }
        },
        mounted() {
            this.popupItem = this.$el
        },
        methods: {
          updateFilter(item) {
              let {title, value} = item
              this.select = title
              let data = {
                  'name': this.field,
                  'value': value
              }
              this.$emit('updateFilter', data)
          }
        },
        computed: {
            list() {
                return this.options
//                const self = this
//                return this.options.filter(function(option) {
//                    return option.toLowerCase() !== self.select
//                });
            },
        },
        created() {
            this.select = this.selected
        }
    }
</script>
<style lang="sass" scoped>
    .select
        cursor: pointer
        position: relative
        &__arrow
            width: 8px
            height: 8px
            border-top: 2px solid rgba($color--dark, 0.4)
            border-right: 2px solid rgba($color--dark, 0.4)
            position: absolute
            top: 48%
            right: 13px
            transform: translateY(-50%) rotate(135deg)
            +tr(transform .3s ease)
        &__title
            +reg
            font-size: 16px
            color: rgba($color--dark, 0.5)
            +tr(color .3s ease)
        &__inner
            cursor: pointer
            display: flex
            justify-content: space-between
            align-items: center
            flex: 1
            height: 48px
            padding: 0 12px
            transition: all 0.4s
            border: 1px solid rgba($color--dark, 0.25)
            border-radius: 4px
            position: relative
            +tr(border-color .3s ease)
            &.is-active,
            &:hover
                border-color: rgba(#2C64FF, 0.7)
                .select__title
                    color: $color--blue
            &.is-active
                .select__arrow
                    transform: rotate(225deg) rotateX(190deg)
                    border-color: $color--blue
    .sub
        background-color: $color--white
        position: absolute
        z-index: 111
        /*padding: 9px 0*/
        top: 57px
        right: 0
        opacity: 0
        width: 72px
        transition: all 0.2s ease
        display: flex
        flex-direction: column
        justify-content: flex-start
        align-items: flex-start
        width: 100%
        border-radius: 4px
        box-shadow: 0px 2px 4px rgba(1, 37, 78, 0.2)
        border-radius: 4px
    .menu
        width: 100%
        display: flex
        justify-content: space-between
        cursor: pointer
        &:not(:first-child)
            /*margin-top: 9px*/
            .menu__title
                border-top: 1px solid $border--color-gray
        &__title
            font-size: 16px
            text-align: left
            +reg
            line-height: 24px
            color: $color--dark
            width: 100%
            +tr(color .3s ease)
            padding: 10px
            &:hover
                background: rgba(44, 100, 255, 0.05)

        &__icon
            position: absolute
            right: 30px
            height: 20px
    .Active
        opacity: 1
    .fade-enter, .fade-leave-to
        opacity: 0

</style>